var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-performance" }, [
    _c("div", { staticClass: "header row" }, [
      _c(
        "div",
        { staticClass: "scores-plane column small-8 medium-8 large-8" },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("company.performance.projectPerformance"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-span" }, [
            _c(
              "span",
              {
                staticClass: "total",
                on: {
                  click: function ($event) {
                    return _vm.goToRatingHistory("")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.totalProjects + " projects"))]
            ),
            _vm._v("/\n        "),
            _c(
              "span",
              {
                staticClass: "total",
                on: {
                  click: function ($event) {
                    return _vm.goToRatingHistory("")
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.evaluationsCounts) +
                    " " +
                    _vm._s(_vm.$t("company.performance.evaluations"))
                ),
              ]
            ),
            _vm._v("/\n        "),
            _c(
              "span",
              {
                staticClass: "total",
                on: {
                  click: function ($event) {
                    return _vm.goToRatingHistory("comments")
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.countsWithComments) +
                    " " +
                    _vm._s(_vm.$t("company.performance.withComments"))
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "indicator" }, [
            _c("span", { staticClass: "average-span" }, [
              _vm._v(_vm._s(_vm.$t("company.performance.itemAverage"))),
            ]),
            _c("span", { staticClass: "most-span" }, [
              _vm._v(_vm._s(_vm.$t("company.performance.mostSelect"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "average-score column small-4 medium-4 large-4" },
        [
          _c("div", { staticClass: "item-title" }, [
            _vm._v(_vm._s(_vm.$t("company.performance.averageScore"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              {
                staticClass: "scores",
                on: {
                  click: function ($event) {
                    return _vm.goToRatingHistory("average")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.totalAverage + "/100"))]
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contant" }, [
      _c("div", { staticClass: "emoji" }, [
        _c("div", { staticClass: "placehold" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "imgs" },
          _vm._l(_vm.srcImgs, function (item, index) {
            return _c("img", {
              key: item,
              attrs: {
                title: _vm.moodCounts[_vm.svgMapToTitle[index]],
                src: "/" + item + "-face.svg",
              },
              on: {
                click: function ($event) {
                  return _vm.goToRatingHistory(item)
                },
              },
            })
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vernier-contant" },
        _vm._l(_vm.titles, function (item) {
          return _c(
            "div",
            { key: item.name.join(""), staticClass: "vernier-wrap" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._l(item.name, function (name, index) {
                    return [
                      index !== 0 ? _c("br", { key: index }) : _vm._e(),
                      _vm._v("\n            " + _vm._s(name) + "\n          "),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vernier" },
                [
                  _c("vernier", {
                    attrs: {
                      percent: item.percent,
                      title: _vm.calcVernierPercent(item.averageScore),
                      secPercent: item.mostSelected.percent,
                      secTitle: "" + item.mostSelected.value,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }